/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_Label_MersisInputs */

const tr_iletisim_s6_label_mersis = /** @type {(inputs: Iletisim_S6_Label_MersisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MERSİS No`)
};

const en_iletisim_s6_label_mersis = /** @type {(inputs: Iletisim_S6_Label_MersisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MERSİS no.`)
};

const de_iletisim_s6_label_mersis = /** @type {(inputs: Iletisim_S6_Label_MersisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MERSİS-Nr.`)
};

const ru_iletisim_s6_label_mersis = /** @type {(inputs: Iletisim_S6_Label_MersisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Номер MERSİS`)
};

/**
* | output |
* | --- |
* | "MERSİS no." |
*
* @param {Iletisim_S6_Label_MersisInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_label_mersis = /** @type {((inputs?: Iletisim_S6_Label_MersisInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_Label_MersisInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_label_mersis(inputs)
	if (locale === "de") return de_iletisim_s6_label_mersis(inputs)
	if (locale === "ru") return ru_iletisim_s6_label_mersis(inputs)
	return tr_iletisim_s6_label_mersis(inputs)
});